import { inject, Injectable } from '@angular/core';
import { NavigationEnd, NavigationStart, Router } from '@angular/router';
import { filter } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class NavigationHistoryService {
  private readonly router = inject(Router);
  private previousUrl: string | null = null;
  private currentUrl: string | null = null;

  constructor() {
    this.currentUrl = this.router.url;

    this.router.events
      .pipe(filter((e): e is NavigationStart => e instanceof NavigationStart))
      .subscribe(() => {
        this.previousUrl = this.currentUrl;
      });

    this.router.events
      .pipe(filter((e): e is NavigationEnd => e instanceof NavigationEnd))
      .subscribe((e: NavigationEnd) => {
        this.currentUrl = e.urlAfterRedirects;
      });
  }

  /** Переход на предыдущий URL через Router (без перезагрузки). Fallback — defaultUrl. */
  back(defaultUrl: string): void {
    const previousPath = this.previousUrl ? this._extractPath(this.previousUrl) : null;
    const url = (this.previousUrl && previousPath !== '/' && previousPath !== '/approve-change-account') ? this.previousUrl : defaultUrl;
    this.router.navigateByUrl(url);
  }

  private _extractPath(url: string): string {
    return url.split('?')[0].split('#')[0];
  }
}
